import { mdlStatus } from "./CompAttachmentsMdl";


export class mdlGetClaimStatusRes {
    public st: mdlStatus;
    public ClaimNoList: Array<mdlClaimNoList> = new Array<mdlClaimNoList>();
    public ClaimStatusList: Array<mdlClaimStatus> = new Array<mdlClaimStatus>();
}
export class mdlClaimNoList {
    SNo: number;
    ClaimNumber: string;
}

export class mdlClaimStatus {
    SNo: string;
    ClaimNumber: string;
    Status: string;
    StatusDesc: string;
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/mdlGetClaimStatusRes .ts